import {
  Box,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  SvgIconProps,
} from "@mui/material";
import { FilePresent } from "@mui/icons-material";
import colors from "../../Constants/colors";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";
import { CompanyDataSource } from "../../Models/evaluation";
import { formatPageRanges } from "../../Helpers/documentHelper";

function isCompanyDataSource(
  file: string | CompanyDataSource,
): file is CompanyDataSource {
  return file != null && typeof file === "object" && "datasource_id" in file;
}

export interface SectionFilesProps {
  files: (string | CompanyDataSource)[];
  icon?: React.ComponentType<SvgIconProps>;
}

export function SectionFiles({
  files,
  icon: Icon = FilePresent,
}: SectionFilesProps) {
  const { colors: workspace } = useWorkspaceColors();
  return (
    <Box
      sx={{
        bgcolor: `${workspace.primary_dark}0F`,
        borderRadius: 2,
        p: 1.5,
        border: `1px solid ${colors.gray200}`,
        borderLeft: `4px solid ${workspace.primary_dark}`,
      }}
    >
      <List dense disablePadding>
        {files.map((file, index) => {
          const label = isCompanyDataSource(file) ? file.document_name : file;
          const pages = isCompanyDataSource(file) ? file.pages : undefined;

          return (
            <ListItem key={index} disablePadding sx={{ py: 0.2 }}>
              <ListItemIcon sx={{ minWidth: 32 }}>
                <Icon
                  sx={{
                    color: workspace.primary_dark,
                    fontSize: "1.5rem",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <span>{label}</span>
                    {pages && pages.length > 0 && (
                      <Chip
                        label={`(${formatPageRanges(pages)})`}
                        size="small"
                        sx={{
                          height: 18,
                          fontSize: "0.7rem",
                          bgcolor: `${workspace.primary_dark}1A`,
                          color: workspace.primary_dark,
                        }}
                      />
                    )}
                  </Box>
                }
                primaryTypographyProps={{
                  variant: "caption",
                  component: "div",
                  sx: { fontFamily: "monospace", fontSize: "0.8rem" },
                }}
              />
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
}
